import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import MenuOutlined from '@ant-design/icons/MenuOutlined';
import MoonOutlined from '@ant-design/icons/MoonOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import SunOutlined from '@ant-design/icons/SunOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import Button from 'antd/es/button';
import Dropdown from 'antd/es/dropdown';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';

import { useDarkMode } from '../../contexts/DarkModeContext';
import { useBreakpoints } from '../../hooks/useIsMobile';
import { MobileMenuDrawer } from '../MobileMenuDrawer/MobileMenuDrawer';

const StyledTopBar = styled.div`
  ${({ theme }) => `
  min-height: ${1.25 * theme.controlHeightLG}px;
  background: ${theme.colorBgContainer};
  border-bottom: ${theme.lineWidth}px ${theme.lineType} ${theme.colorBorder};
  width: 100%;
  padding-inline: ${theme.paddingSM}px;
  box-sizing: border-box;

  @container app (width >= ${theme.screenXS}px) {
    display: none;
  }
`}
`;

const StyledLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

const StyledSide = styled.div`
  ${({ theme }) => `
  display: flex;
  align-items: center;
  gap: ${theme.marginXS}px;
  height: 100%;
`}
`;

const StyledTopBarButton = styled(Button)`
  ${({ theme }) => `
  border-radius: ${theme.controlHeight * 5}px;
`}
`;

export const TopBar = () => {
  const [isDarkMode, setIsDarkMode] = useDarkMode();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { isMobile } = useBreakpoints();

  useEffect(() => {
    if (!isMobile) {
      setIsMobileMenuOpen(false);
    }
  }, [isMobile]);

  return (
    <>
      <StyledTopBar>
        <StyledLayout>
          <StyledSide>
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setIsMobileMenuOpen(true)}
            />
          </StyledSide>
          <StyledSide>
            <Dropdown
              menu={{
                items: [
                  {
                    key: 'profile',
                    label: <Link to="/profile">Profile</Link>,
                    icon: <UserOutlined />,
                  },
                  {
                    key: 'toggle-theme',
                    label: 'Toggle Theme',
                    onClick: () => {
                      setIsDarkMode((prev) => !prev);
                    },
                    icon: isDarkMode ? <SunOutlined /> : <MoonOutlined />,
                  },
                  {
                    key: 'divider',
                    type: 'divider',
                  },
                  {
                    key: 'logout',
                    label: <Link to="/auth/login">Logout</Link>,
                    icon: <LogoutOutlined />,
                  },
                ],
              }}
            >
              <StyledTopBarButton icon={<SettingOutlined />} />
            </Dropdown>
          </StyledSide>
        </StyledLayout>
      </StyledTopBar>
      <MobileMenuDrawer
        open={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
      />
    </>
  );
};
